var map = {
	"./AverageIcon.svg": "b22f",
	"./FAQ.svg": "3533",
	"./GoodIcon.svg": "d18d",
	"./GreatIcon.svg": "2f58",
	"./Insta.svg": "649e",
	"./MTNRadio.svg": "661f",
	"./OopsRight.svg": "7eec",
	"./PoorIcon.svg": "4287",
	"./ReturnBack.svg": "8f12",
	"./SMS.svg": "2b1f",
	"./WorstIcon.svg": "32d0",
	"./account.svg": "ecec",
	"./apple.svg": "f9d5",
	"./applewhite.svg": "a83f",
	"./ar.svg": "3257",
	"./arrows.svg": "9ce4",
	"./backArrow.svg": "3c3d",
	"./black-arrow.svg": "bcb4",
	"./black.svg": "b2da",
	"./blackCircle.svg": "a2a9",
	"./bundlesBackground.svg": "a97f",
	"./buttonArrow.svg": "7756",
	"./calls.svg": "1af1",
	"./cardtest.svg": "aac0",
	"./center.svg": "7dcb",
	"./close-yellow-button.svg": "0fe3",
	"./closeBtn.svg": "b43d",
	"./closeSupport.svg": "d33d",
	"./code.svg": "100a",
	"./contact.svg": "d015",
	"./contactNumber.svg": "343d",
	"./contactUser.svg": "2160",
	"./digitalServices.svg": "8208",
	"./down-arrow.svg": "fcc4",
	"./down-white-arrow.svg": "4018",
	"./edit-border.svg": "881a",
	"./edit.svg": "daf0",
	"./emailIcon.svg": "f5f4",
	"./en.svg": "eff4",
	"./error.svg": "28c3",
	"./exploreArrow.svg": "ab69",
	"./exploreButton.svg": "1607",
	"./face.svg": "1543",
	"./facebook-dialog.svg": "4d64f",
	"./facebook.svg": "8485",
	"./faxIcon.svg": "01ac",
	"./feedback.svg": "eaaf",
	"./financialReport.svg": "b200",
	"./generalMessage.svg": "4a23",
	"./google.svg": "d950",
	"./googlewhite.svg": "8ad7",
	"./gradient-arabic.svg": "90be",
	"./gradient-card.svg": "8332",
	"./homeIcon.svg": "fceb",
	"./hover-facebook.svg": "59f0",
	"./hover-instagram.svg": "909b",
	"./hover-linked-in.svg": "c6cc",
	"./info.svg": "76ed",
	"./instagram-dialog.svg": "302f",
	"./instagram.svg": "bd6c",
	"./internet.svg": "78cd",
	"./lang.svg": "086b",
	"./linked-in.svg": "a76f",
	"./linkedin.svg": "9ed9",
	"./logout-arrow.svg": "d496",
	"./logout-line.svg": "c32a",
	"./massenger.svg": "5b00",
	"./minesIcon.svg": "f618",
	"./mobilecard.svg": "764f",
	"./mtn-white.svg": "3bce",
	"./mtnapps.svg": "4f98",
	"./none-fill-pdf.svg": "7893",
	"./oopsLeft.svg": "eaab",
	"./outer-card.svg": "ef5c",
	"./pdf.svg": "5730",
	"./phoneIcon.svg": "9402",
	"./plusIcon.svg": "47e0",
	"./prices.svg": "948c",
	"./rabesh.svg": "e02a",
	"./readmore.svg": "49c2",
	"./reservationBack.svg": "7763",
	"./reservationDetails.svg": "a084",
	"./reservationFormSmall.svg": "627f",
	"./reservationNumber.svg": "230b",
	"./reserveForm.svg": "f130",
	"./reserveNumberLeft.svg": "1a77",
	"./reserveNumberRight.svg": "cea9",
	"./rightArrow.svg": "8ce4",
	"./search-el.svg": "fe36",
	"./search.svg": "d103",
	"./searchIcon.svg": "444d",
	"./services.svg": "128b",
	"./share.svg": "bd5b",
	"./small-arrow.svg": "61e3",
	"./small-black-arrow.svg": "e5f3",
	"./smallFeedback.svg": "770c",
	"./swipe.svg": "ef46",
	"./telegram.svg": "2b29",
	"./test.svg": "4498",
	"./test2.svg": "8241",
	"./testcard.svg": "b70a",
	"./trouble.svg": "3287",
	"./tv.svg": "e678",
	"./twitter.svg": "acf9",
	"./validation.svg": "c513",
	"./whatsapp.svg": "7583",
	"./white-arrow.svg": "6806",
	"./white-back-arrow.png": "afb2",
	"./white-swipe.svg": "2e61",
	"./whiteCircle.svg": "5a10",
	"./wide-card-btn.svg": "6bac",
	"./yellow-arrow.svg": "befe",
	"./yellow-arrows.svg": "6e2f",
	"./yellow-share-btn.svg": "7453",
	"./yellowArrow.svg": "4233"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";